import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextInput,
  translate as t,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
import TranslatableInput from '../components/inputs/TranslatableInput';
import TranslatableField from '../components/fields/TranslatableField';

export const DietList = (props) => (
  <List {...props}>
    <Datagrid>
      <TranslatableField source="title" />
      <EditButton {...props} basePath="/diets" />
      <DeleteButton {...props} basePath="/diets" />
    </Datagrid>
  </List>
);

const DietTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.name }) : ''}</span>
));

export const DietEdit = (props) => (
  <Edit title={<DietTitle />} {...props}>
    <SimpleForm>
      <TranslatableInput source="title" />
    </SimpleForm>
  </Edit>
);

export const DietCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput source="name" />
      <TranslatableInput source="title" />
    </SimpleForm>
  </Create>
);
